<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.EDIT') }} {{ $t('ITEM.COLOR') }}
      </span>
      <v-spacer />
      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="d-flex justify-center">
      <v-color-picker
        v-model="color"
        mode="hexa"
        :hide-mode-switch="true"
      ></v-color-picker>
    </v-card-text>
    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-spacer />

      <v-btn depressed color="primary" @click="create">
        {{ $t('BUTTON.SAVE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
const DEFAULT_COLOR = '5F9E42';

export default {
  name: 'ColorPicker',

  props: {
    value: {
      type: String,
      default: DEFAULT_COLOR
    }
  },

  data: () => ({
    color: null
  }),

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler: 'valueWatchHandler'
    },
    color(value) {
      // temporary fix while there is no way to disable the alpha channel in the colorpicker component: https://github.com/vuetifyjs/vuetify/issues/9590
      if (value.toString().match(/#[a-zA-Z0-9]{8}/)) {
        this.color = value.substr(0, 7);
      }
    }
  },

  methods: {
    valueWatchHandler(v) {
      if (v === null) {
        this.color = DEFAULT_COLOR;
      } else {
        this.color = v;
      }
    },
    create() {
      this.$emit('update', this.color);
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style scoped></style>
